/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoSendInvitationInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type ExternalContactShowHeroCardMutationVariables = {
    input: infoSendInvitationInput;
};
export type ExternalContactShowHeroCardMutationResponse = {
    readonly infoSendInvitation: {
        readonly contact: {
            readonly slug: string;
        };
    } | null;
};
export type ExternalContactShowHeroCardMutation = {
    readonly response: ExternalContactShowHeroCardMutationResponse;
    readonly variables: ExternalContactShowHeroCardMutationVariables;
};



/*
mutation ExternalContactShowHeroCardMutation(
  $input: infoSendInvitationInput!
) {
  infoSendInvitation(input: $input) {
    contact {
      slug
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalContactShowHeroCardMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoSendInvitationPayload",
        "kind": "LinkedField",
        "name": "infoSendInvitation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalContactShowHeroCardMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoSendInvitationPayload",
        "kind": "LinkedField",
        "name": "infoSendInvitation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e91df6b244ca8594831d24e063d6d872",
    "id": null,
    "metadata": {},
    "name": "ExternalContactShowHeroCardMutation",
    "operationKind": "mutation",
    "text": "mutation ExternalContactShowHeroCardMutation(\n  $input: infoSendInvitationInput!\n) {\n  infoSendInvitation(input: $input) {\n    contact {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e8154182088d241dabe2368353d49de1';
export default node;
